import { RouteObject } from 'react-router-dom';

// This function will be called in App.tsx where JSX is allowed
export function getRoutes(): RouteObject[] {
  return [
    {
      path: '/',
      // Space Ops page - landing page
      index: true,
    },
    {
      path: '/gatherings',
      // Gatherings board page
    },
    {
      path: '/users',
      // Users page
    },
    {
      path: '/check-ins',
      // Check-ins page
    },
    {
      path: '/caas/clients',
      // CaaS Partners list page
    },
    {
      path: '/caas/clients/:clientId',
      // CaaS Client detail page
    },
    {
      path: '/caas/clients/:clientId/teams/:teamId',
      // CaaS Team detail page
    },
    {
      path: '/gatherings/past',
      // Past gatherings search page
    },
    {
      path: '*',
      // Redirect to home
    },
  ];
}

export default getRoutes;
